import { EmployeeProfile, OtherTransactions, ProfileInfo } from "components";
import { ElementWrapper } from "components/BaseComponents/Flex";
import { useAppSelector } from "redux/hooks";

const ProfileScreen = () => {
  const { userOtp } = useAppSelector((state) => state.otp);

  return (
    <>
      <ElementWrapper
        width='872px'
        minHeight='calc(100vh - 140px)'
        direction='column'
        justifyContent='flex-start'
        alignItems='flex-start'
        margin='10px auto auto auto'
      >
        <ProfileInfo />
        {(userOtp?.UserLevel === "1" || userOtp?.UserLevel === "3") && (
          <>
            <EmployeeProfile />
            <OtherTransactions />
          </>
        )}
      </ElementWrapper>
    </>
  );
};

export default ProfileScreen;
